/**
 * author antoine.nivet
 */
export default function chunkToTimeString(chunksService) {
  return function(chunk, startChunk) {
    return chunksService.chunkToTimeString(chunk, startChunk);
  };
}



// WEBPACK FOOTER //
// ./src/app/common/chunkToTimeString.filter.js